<template>
    <a-modal
        :confirm-loading="confirmLoading"
        :title="$t('wp.typeInANumberDesc')"
        :visible="localVisibleStartChat"
        class="row d-flex flex-row"
        @cancel="handleCancel"
        @ok="handleOk(wpContactNumber)"
    >
        <div v-if="showAlertMessage" class="pb-3">
            <a-alert :message="$t('wp.toLittleChar')" type="error" banner />
        </div>
        <div class="d-flex flex-row align-items-center justify-content-center">
            <vue-country-code
                :defaultCountry="userLastCountry"
                :enabledCountryCode="true"
                class="col-3 country-code"
                @onSelect="onSelect($event)"
            />
            <div class="col-8">
                <a-input
                    v-model="wpContactNumber"
                    :placeholder="$t('message.phone')"
                    autocomplete="off"
                    trim
                    type="text"
                />
            </div>
        </div>
    </a-modal>

</template>
<script>
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";
import { sendSocketMessage, socketMessageStream } from "../../../utils/socketStream";
import { filter, first, timeout } from "rxjs/operators";
import _ from "lodash";
import { mapGetters, mapMutations, mapState } from "vuex";
import Vue from "vue";
import VueCountryCode from "vue-country-code";
import log2 from "../../../utils/log2";
import { VePagination } from "vue-easytable";

Vue.use(VePagination);
Vue.use(VueCountryCode);
const log = log2("WhatsappContactList");
export default {
    name: "WhatsappContactList",
    components: {
        VueCountryCode,
    },
    props: {
        visibleStartChat: {
            type: Boolean,
            default: false,
        },
        channelId: {
            type: String,
            required: true,
        },
        channel: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            wpContactNumber: "",
            loading: false,
            internationalCallingCode: "",
            loadingInstance: null,
            showAlertMessage: false,
            localVisibleStartChat: this.visibleStartChat,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            siteId: (state) => state.site.site._id,
            user: (state) => state.auth.user,
            userLastCountry: (state) => _.get(state.auth.user, "lastGeoLocation.country"),
            channelContacts: (state) => state.whatsapp.channelContacts,
            channelInfo: (state) => state.whatsapp.channelInfo,
        }),

        ...mapGetters({
            myActiveConversations: "chat/getMyActiveConversations",
        }),
    },
    methods: {
        ...mapMutations({
            changePurchaseStatus: "whatsapp/changePurchaseStatus",
            setSearchingResultWPContact: "whatsapp/setSearchingResultWPContact",
        }),
        getContacts() {
            return _.get(this.channelContacts, [this.channel._id, "contacts"], []) || [];
        },
        getSearchingResultsOfWpContact() {
            return _.get(this.channelContacts, [this.channel._id, "searchingResultsOfWpContact"], []) || [];
        },
        startChat(whatsappNumber) {
            const isBusiness = this.channel?.type === "whatsapp-business-api";
            const isWhatsappV2 = this.channel?.type === "whatsapp-v2";
            const isWhatsappV1 = this.channel?.type === "whatsapp-v1";
            if (isWhatsappV1 && this.channelInfo[this.channel._id].status.status.STATE !== "CONNECTED") {
                this.$message.error("Whatsapp bağlantısı yok"); // todo translate
                return;
            }
            if (isWhatsappV2 && this.channelInfo[this.channel._id]?.status?.state !== "READY") {
                this.$message.error("Whatsapp bağlantısı yok"); // todo translate
                return;
            }
            if (isWhatsappV1 || isWhatsappV2) {
                whatsappNumber = whatsappNumber.includes("@c.us") ? whatsappNumber : whatsappNumber + "@c.us";
            }

            const maybeJoinedChat = this.myActiveConversations.find((x) => x.whatsappNumber === whatsappNumber);
            if (!!maybeJoinedChat) {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_CHAT, {
                    conversationId: maybeJoinedChat._id,
                });
            } else {
                const hide = this.$message.loading(this.$t("wp.chatStartingWait"), 0);

                socketMessageStream
                    .pipe(
                        filter((x) => x.cmd === "join_chat_immediately"),
                        timeout(5000),
                        first(),
                    )
                    .toPromise()
                    .then((x) => {
                        this.$message.success(this.$t("wp.chatStarted"));
                        this.$router.push("/chat");
                    })
                    .catch((err) => {
                        this.$message.error(this.$t("wp.chatNotStarted"));
                    })
                    .finally(() => {
                        hide();
                    });
                sendSocketMessage("user start-chat", {
                    siteId: this.site._id,
                    userId: this.user._id,
                    whatsappNumber: whatsappNumber,
                    channelId: this.channel._id,
                    channelType: this.channel.type,
                });
            }
        },
        onSelect(value) {
            log("onSelect", value);
            this.internationalCallingCode = value.dialCode;
        },
        handleOk(number) {
            this.wpContactNumber = number.replace(/[{()}]/g, "");
            const contactNumber = this.internationalCallingCode + this.wpContactNumber;
            if (contactNumber.length < 6) {
                this.showAlertMessage = true;
                return;
            }
            this.confirmLoading = true;
            this.showAlertMessage = false;
            this.localVisibleStartChat = false;
            this.confirmLoading = false;

            const searchingResultsOfWpContact = this.getSearchingResultsOfWpContact();
            const searchedContacts = JSON.parse(JSON.stringify(searchingResultsOfWpContact));
            const isNumberExistInSearchHistory = searchedContacts[number];
            if (isNumberExistInSearchHistory !== undefined) {
                this.readyToChatStartingControl(isNumberExistInSearchHistory);
            } else {
                socketMessageStream
                    .pipe(
                        filter((x) => x.cmd === "whatsapp_contacts_is_includes_number"),
                        timeout(5000),
                        first(),
                    )
                    .toPromise()
                    .then((x) => {
                        let searchingResultWPContact = {};
                        const isExist = _.get(x, "data.contactIsExist") || false;
                        searchingResultWPContact[`${number}`] = isExist;
                        this.readyToChatStartingControl(isExist);
                        this.setSearchingResultWPContact(searchingResultWPContact, this.channel._id);
                    })
                    .catch((err) => {
                        this.$message.error(this.$t("wp.chatNotStarted"));
                    });

                sendSocketMessage("whatsapp number-is-exist-in-contacts", {
                    siteId: this.site._id,
                    searchingPhoneNumber: contactNumber,
                    channelId: this.channel._id,
                });
            }
        },
        readyToChatStartingControl(isExist) {
            this.startChat(this.internationalCallingCode + this.wpContactNumber);
        },
        handleCancel(e) {
            this.localVisibleStartChat = false;
            this.showAlertMessage = false;
            this.$emit('modal-closed');
        },
    },
    mounted() {
    },
    watch: {
        channelContacts: {
            handler: function(newValue) {
                const total = _.get(newValue, [this.channel._id, "total"], 0) || 0;
            },
            deep: true,
        },
        loading(val) {
            if (val) {
                this.loadingInstance.show();
            } else {
                this.loadingInstance.close();
            }
        },
        visibleStartChat(newVal) {
            this.localVisibleStartChat = newVal;
        },
    },
};
</script>
<style lang="scss" scoped></style>
